import { User } from 'src/graphql/generated/graphql';

export const getWttpResponseFiltersBasedOnUser = (
  user: User,
  { isAdmin, isOtpPro }: { isAdmin: boolean; isOtpPro: boolean },
) => {
  return {
    assignedToUserIds: !isAdmin && !isOtpPro && user ? [user.id] : undefined,
  };
};
